module.exports = __webpack_public_path__ + "img/maitekai.3edd37d6.png";